import {
  DELIVERY_DETAILS_REDESIGN_VIEW,
  DELIVERY_DETAILS_VIEW,
  ORDER_OK_VIEW,
  PAYMENT_DETAILS_VIEW,
  PAYMENT_REDESIGN_DETAILS_VIEW,
  SHOPCART_DISPLAY_VIEW,
} from '@/scripts/constants/pages'

export enum FrameAdvisorKeys {
  PROFILE_DATA = 'frameAdvisorProfileData',
  SESSION_DATA = 'frameAdvisorSessionData',
  FLOATING_BUTTON_MINIMIZED = 'frameAdvisorFloatingButtonMinimized',
  INITIALIZED = 'frameAdvisorInitialized',
  ANALYSIS_RESULTS = 'frameAdvisorAnalysisResults',
}

export enum SizeAdvisorKeys {
  PLP_TOGGLE_STATUS = 'sizeAdvisorPlpToggleStatus',
  RECOMMENDED = 'recommended',
  ALSO_RIGHT_FOR_YOU = 'also-right-for-you',
  TIGHT = 'tight',
  NEXT_BEST_SIZE = 'next-best-size',
  LOOSE = 'loose',
}

export const FrameGeniusExcludedPages = [
  SHOPCART_DISPLAY_VIEW,
  DELIVERY_DETAILS_VIEW,
  PAYMENT_DETAILS_VIEW,
  ORDER_OK_VIEW,
  DELIVERY_DETAILS_REDESIGN_VIEW,
  PAYMENT_REDESIGN_DETAILS_VIEW,
]
